// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".question-forward-box[data-v-70e547ec]{background:#fff;border-radius:1rem;padding:35px 25px;text-align:center}@media screen and (max-width:768px){.question-forward-box[data-v-70e547ec]{padding:20px 15px}}.box-title[data-v-70e547ec]{font-size:32px;line-height:1.33}@media screen and (max-width:768px){.box-title[data-v-70e547ec]{margin-bottom:15px}}.input-wrapper[data-v-70e547ec]{margin:25px 0 5px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
